import React from 'react';
import { Typo, Icon, Button } from '@ers/ui';
import { StateManagerProps } from '../Offer';
import { BigIconPanel } from '../..';

const NoOffer = ({ nextState }) => (
    <div className="offerlink offerlink--center">
        <BigIconPanel>
            <Icon name="briefcase" big />
            <div className="with-margin--left-2">
                <Typo.Body>
                    Dodaj link do ogłoszenia o pracę, żeby mieć wszystkie informacje w
                    jednym miejscu
                </Typo.Body>
                <Button.Secondary onClick={nextState} className="with-margin--top-3">
                    Dodaj ogłoszenie
                </Button.Secondary>
            </div>
        </BigIconPanel>
    </div>
);

NoOffer.propTypes = StateManagerProps;

export default NoOffer;
